var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import React, { PureComponent } from "react";
import { isEmpty } from "lodash";
import { Row, Col } from "react-bootstrap";
import id from "@irati/utils/id";
import Hr from "@irati/ui/src/Layout/Hr";
import Form from "@irati/ui/src/Form";
import { Input } from "@irati/ui/src/FormItem";
import Error from "@irati/ui/src/ErrorText";
import Validation from "@irati/utils/validation";
import { FormattedMessage, injectIntl } from "@irati/utils/lang";
import Loading from "@irati/ui/src/Loading";
import { Firstname, Lastname, Email, ExternalID } from "@irati-web/fields/user";
import EditUserRole from "@irati-web/fields/roles/User";
import userService from "@irati/identity/services/users";
import Button from "@irati/ui/src/Button";
import { mobileSchema } from "@irati/admin/helpers/validation/schema";
import { SelectWithMargin, ButtonWrapper } from "./styled";
var EditUserForm = /** @class */ (function (_super) {
    __extends(EditUserForm, _super);
    function EditUserForm() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = {
            error: null
        };
        _this.handleUpdateRole = function () { return __awaiter(_this, void 0, void 0, function () {
            var user;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, userService.get(this.props.selectedUser.uuid, { fetchPolicy: "network-only" })];
                    case 1:
                        user = _a.sent();
                        this.props.updateSelectedUser(__assign({}, user));
                        return [2 /*return*/];
                }
            });
        }); };
        _this.handleUpdateSelectedUser = function (label, value) {
            var _a;
            _this.props.updateSelectedUser(__assign(__assign({}, _this.props.selectedUser), (_a = {}, _a[label] = value, _a)));
        };
        _this.updateTeams = function (value) {
            _this.handleUpdateSelectedUser("teamIds", (value === null || value === void 0 ? void 0 : value.map(function (option) { return option.value; })) || []);
        };
        _this.handleSave = function () {
            var _a = _this.props, formatMessage = _a.formatMessage, handleSave = _a.handleSave;
            Validation.validate()
                .then(function () {
                handleSave();
            })
                .catch(function () {
                _this.setState({
                    error: formatMessage({ id: "admin.people.edituser.validation.error" })
                });
            });
        };
        return _this;
    }
    EditUserForm.prototype.render = function () {
        var _this = this;
        var _a = this.props, selectedUser = _a.selectedUser, formatMessage = _a.formatMessage, handleCancel = _a.handleCancel, teams = _a.teams, load = _a.load, loadRef = _a.loadRef, ref = _a.ref;
        var error = this.state.error;
        var idNamespace = id("EditUserForm", this.props);
        var teamOptions = teams.map(function (team) { return ({ value: team.uuid, label: team.public_name }); });
        var userTeams = teamOptions.filter(function (_a) {
            var _b;
            var value = _a.value;
            return (_b = selectedUser.teamIds) === null || _b === void 0 ? void 0 : _b.includes(value);
        });
        var placeholder = teamOptions
            ? formatMessage({ id: "admin.components.userProfilePopUp.reactSelect.placeholder.select" })
            : formatMessage({ id: "admin.components.userProfilePopUp.reactSelect.placeholder.noResultsFound" });
        var isManagedExternally = selectedUser.isManagedExternally;
        return (React.createElement(Form, { id: idNamespace },
            React.createElement(Row, null,
                React.createElement(Col, { xs: 6 },
                    React.createElement(Firstname, { value: selectedUser.firstName, disabled: isManagedExternally, hint: isManagedExternally ? formatMessage({ id: "admin.people.edituser.sso" }) : null, onChange: function (value) { return _this.handleUpdateSelectedUser("firstName", value); } })),
                React.createElement(Col, { xs: 6 },
                    React.createElement(Lastname, { value: selectedUser.lastName, disabled: isManagedExternally, hint: isManagedExternally ? formatMessage({ id: "admin.people.edituser.sso" }) : null, onChange: function (value) { return _this.handleUpdateSelectedUser("lastName", value); } }))),
            React.createElement(EditUserRole, { user: selectedUser, team: null, onChange: this.handleUpdateRole }),
            React.createElement(ExternalID, { value: selectedUser.externalUserId, hint: formatMessage({ id: "admin.components.userProfilePopUp.form.externalID.hint" }), onChange: function (value) { return _this.handleUpdateSelectedUser("externalUserId", value); } }),
            React.createElement(Hr, null),
            !isEmpty(teams) && (React.createElement(React.Fragment, null,
                React.createElement("label", { htmlFor: "select_team" },
                    React.createElement(FormattedMessage, { id: "admin.components.userProfilePopUp.form.fields.label" })),
                React.createElement(SelectWithMargin, { isMulti: true, name: "team", id: "select_team", placeholder: placeholder, value: userTeams, scrollMenuIntoView: false, onChange: this.updateTeams, options: teamOptions }),
                React.createElement(Hr, null))),
            React.createElement(Email, { value: selectedUser.email, hint: isManagedExternally ? formatMessage({ id: "admin.people.edituser.sso" }) : null, disabled: isManagedExternally, onChange: function (value) { return _this.handleUpdateSelectedUser("email", value); } }),
            React.createElement(Input, { label: "account.profile.fields.mobile.label", value: selectedUser.phoneNumber, disabled: isManagedExternally, hint: isManagedExternally ? formatMessage({ id: "admin.people.edituser.sso" }) : null, name: "phone", onChange: function (value) { return _this.handleUpdateSelectedUser("phoneNumber", value); }, validation: mobileSchema() }),
            React.createElement(Hr, null),
            React.createElement(Loading, { load: load, useLoader: false }),
            !!error && React.createElement(Error, null, error),
            React.createElement(ButtonWrapper, { justifyContent: "flex-end", alignItems: "center" },
                React.createElement(Button, { onClick: handleCancel, disabled: !!load, tertiary: true, marginRight: 2 },
                    React.createElement(FormattedMessage, { id: "account.editProfile.button.cancel" })),
                React.createElement(Button, { ref: ref, onClick: this.handleSave, load: load, loadRef: loadRef, primary: true },
                    React.createElement(FormattedMessage, { id: "admin.components.userProfilePopUp.saveButton.text" })))));
    };
    return EditUserForm;
}(PureComponent));
export default injectIntl(EditUserForm);
